import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e87c064"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full flex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 th h-full" }, "特記事項", -1))
const _hoisted_3 = { class: "col-8 td overflow-scroll" }
const _hoisted_4 = {
  key: 0,
  class: "absolute bottom-0 w-full button-container cursor-pointer"
}
const _hoisted_5 = {
  key: 1,
  class: "flex w-full"
}

import { useStore } from "vuex";
import { get, set } from "@vueuse/core";
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";
import { ref, onMounted, watch } from "vue";
import { CustomerServices } from "@/clinic/services";
import { ApiCustomerNewReq, ICustomer } from "@/clinic/typings";
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import SpecialNoteInput from "./SpecialNoteInput.vue";
import { MAX_SPECIAL_NOTE } from "@/clinic/typings/constants/clinic";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";


export default /*#__PURE__*/_defineComponent({
  __name: 'SpecialNote',
  props: {
    customer: null
  },
  setup(__props: any) {

const props = __props as {
  customer: ICustomer;
};

const toast = useToast();
const store = useStore();
const confirm = useConfirm();


const defaultSpecialNote = { content: "" };

const specialNotes = ref(props.customer.special_notes_attributes);
const savedStatus = ref(false);
const editable = ref(false);

onMounted(() => {
  if (get(specialNotes)) {
    setSpecialNotes(get(specialNotes));
  }
});

watch(
  () => props.customer.special_notes_attributes,
  newNotes => {
    if (newNotes) {
      setSpecialNotes(newNotes);
    }
  }
);

const setSpecialNotes = (notes: any) => {
  const addNum = MAX_SPECIAL_NOTE - (notes.length || 0);
  if (addNum > 0) {
    notes = [...notes, ...Array.from({ length: addNum }, () => ({ ...defaultSpecialNote }))];
  }
  set(specialNotes, notes);
};

const submit = async () => {
  const notes = get(specialNotes)?.filter(
    (note: any) => Object.keys(note).length > 0 && (note.content != "" || note._destroy)
  );
  const params = { id: Number(props.customer.id), clinic_id: store.getters["authClient/selectedClinic"].id };
  const payload = { special_notes_attributes: notes } as unknown as ApiCustomerNewReq;
  const successCallback = (response: any) => {
    setSpecialNotes(response.special_notes_attributes);
    notifySuccessMsg(toast, "保存しました");
    set(savedStatus, true);
    set(editable, false);
  };
  const errorCallback = (error: any) => notityErrorMsg(toast, error.response.data[0]);

  if (notes && notes.length > 0) {
    confirm.require({
      message: "保存しますか？",
      header: "注意",
      rejectLabel: "キャンセル",
      acceptLabel: "OK",
      accept: async () => {
        await CustomerServices.saveCustomer(
          params,
          payload,
          (response: any) => successCallback(response),
          (error: any) => errorCallback(error)
        );
      },
    });
  }
};

const toggleSavedStatus = () => set(savedStatus, false);
const toggleEditable = () => set(editable, !get(editable));

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specialNotes.value, (specialNote, index) => {
        return (_openBlock(), _createBlock(SpecialNoteInput, {
          key: specialNote.id,
          note: specialNote,
          index: index,
          savedStatus: savedStatus.value,
          editable: editable.value,
          onToggleSavedStatus: toggleSavedStatus
        }, null, 8, ["note", "index", "savedStatus", "editable"]))
      }), 128))
    ]),
    (_unref(store).getters['authClient/selectedClinic'].partner == _unref(ClinicPartner).Unaffiliated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (!editable.value)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: "編集",
                class: "p-button w-full",
                onClick: toggleEditable
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_Button, {
                  label: "キャンセル",
                  class: "p-button-light flex-1",
                  style: {"border":"none"},
                  onClick: toggleEditable
                }),
                _createVNode(_component_Button, {
                  label: "保存",
                  class: "p-button flex-1",
                  onClick: submit
                })
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})